import Vue from 'vue';
import Vuex from 'vuex';
// Vuex modules
// Data model stores

// Service stores
import notification from './modules/notification';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: {
    notification,
  },
  strict: process.env.NODE_ENV !== 'production',
});
